import { render } from "./HeroiconsSolidLogout.vue?vue&type=template&id=c358ff56"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLogout.vue"]])

export default __exports__